import React from "react";
import merge from "lodash/merge";
import { TextField, RaisedButton } from "material-ui";
import { colors as Colors } from "material-ui/styles";
import connectToStores from "alt-utils/lib/connectToStores";
import CouponStore from "../../stores/CouponStore";
import CouponActions from "../../actions/CouponActions";
import LinkLike from "./link-like.jsx";

@connectToStores
class OrderExtraEntry extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isRevealed: false,
      enteredCode: null,
      lastCheckedQuantity: null,
      codeChecked: false
    };

    this.getStyles = this.getStyles.bind(this);
    this.onSubmitCode = this.onSubmitCode.bind(this);
    this.onRevealClick = this.onRevealClick.bind(this);
    this.updateCode = this.updateCode.bind(this);
    this.onSubmitGift = this.onSubmitGift.bind(this);
    this.onResetGift = this.onResetGift.bind(this);
    this.onResetCode = this.onResetCode.bind(this);
  }

  static get contextTypes() {
    return {
      tenant: React.PropTypes.object
    };
  }

  static getStores() {
    return [CouponStore];
  }

  static getPropsFromStores() {
    return CouponStore.getState();
  }

  componentWillReceiveProps(props) {
    if (
      props.order &&
      props.initialCouponCode &&
      this.state.enteredCode !== props.initialCouponCode
    ) {
      this.updateCode(props.initialCouponCode);
    }

    let quantity =
      props.order &&
      props.order.subitems.reduce((t, i) => t + (i.quantity || 0), 0);
    if (
      (props.isCouponValid || this.state.enteredCode) &&
      quantity !== this.state.lastCheckedQuantity
    ) {
      this.setState({ lastCheckedQuantity: quantity, codeChecked: true }, () => {
        this.onSubmitCode();
      });
    }

    if (props.updateCouponStatus && this.state.codeChecked) {
      if (props.isCheckingCode && props.isCouponValid === false) {
        props.updateCouponStatus(undefined);
      }
      else {
        props.updateCouponStatus(props.isCouponValid);
      }
    }
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillUnmount() {
    this.setState({ codeChecked: false });
  }

  getStyles() {
    return {
      note: {
        padding: 10,
        marginTop: this.props.order.price === 0 ? -15 : 0,
        marginBottom: 35 / 3,
        backgroundColor: this.props.isSundance ? null : Colors.yellow300
      },
      hint: {
        textAlign: "right",
        marginTop: 10,
        marginBottom: 35
      },
      entry: {
        textAlign: "right",
        marginTop: 10,
        marginBottom: 20
      },
      error: {
        color: "#fff",
        backgroundColor: Colors.red600,
        padding: 10
      }
    };
  }

  onRevealClick() {
    this.setState({
      isRevealed: true
    });
  }

  onResetCode() {
    CouponActions.reset();
    this.updateCode("");
    this.props.updateCurrentOrder({ coupon: null });
  }

  onSubmitCode() {
    CouponActions.checkCouponCode.defer(
      this.state.enteredCode || this.props.order.coupon_code,
      merge({}, this.props.order, { coupon: null, name: null })
    );
  }

  updateCode(code) {
    if (!code) {
      this.setState({ isRevealed: false, enteredCode: "" });
      return;
    }

    this.setState({ isRevealed: true, enteredCode: code }, () => {
      this.onSubmitCode();
    });
  }

  onSubmitGift() {
    this.props.updateCurrentOrder({
      gift: true
    });
  }

  onResetGift() {
    this.props.updateCurrentOrder({
      gift: false
    });
  }

  render() {
    var styles = this.getStyles();
    var offerGiftCard = this.context.tenant.offer_gift_cards;

    return (
      <div style={this.props.style}>
        {this.props.isCouponValid ? (
          <div
            id="Eventive--orderDiscountEntry--discountApplied"
            style={styles.note}
          >
            {this.props.couponIsGiftCard ? (
              <span>{this.props.couponName} applied successfully.</span>
            ) : (
              <span>
                "{this.props.couponName}" discount applied successfully.
              </span>
            )}{" "}
            {this.props.isWidgetView ? null : (
              <span>
                (<LinkLike
                   onClick={this.onResetCode}
                   style={this.props.isSundance ? { fontSize: 13, color: "#000" } : {}}>remove</LinkLike>)
              </span>
            )}
          </div>
        ) : null}
        {this.props.order.gift ? (
          <div style={styles.note}>
            <strong>It's a gift!</strong> You can send or download a redeemable
            gift certificate after placing your order. (
            <LinkLike onClick={this.onResetGift}>cancel</LinkLike>)
          </div>
        ) : null}
        {!this.props.isCouponValid &&
        (this.state.isRevealed || this.props.salesLocked) ? (
          this.props.isWidgetView ? (
            <div>
              {this.props.couponError ? (
                <div style={styles.error}>
                  {this.props.couponError}{" "}
                  <strong>
                    If you proceed to place your order, you will be charged full
                    price with no discount.
                  </strong>
                </div>
              ) : (
                <div
                  id="Eventive--orderDiscountEntry--discountApplied"
                  style={styles.note}
                >
                  Applying discount...
                </div>
              )}
            </div>
          ) : (
            <div
              style={Object.assign(
                {},
                styles.entry,
                this.props.salesLocked && { textAlign: "center" }
              )}
            >
              <TextField
                id="Eventive--orderDiscountEntry--discountField"
                hintText={
                  this.props.isSundance
                    ? "Promo Code"
                    : this.props.salesLocked
                    ? "Unlock code"
                    : offerGiftCard
                    ? "Discount code or gift card"
                    : "Discount code"
                }
                style={
                  this.props.isSundance
                    ? { maxWidth: "60%", border: "1px solid #e9e9e9", paddingLeft: 10, paddingRight: 5, marginRight: 10 }
                    : { maxWidth: "60%" }
                  }
                value={this.state.enteredCode || ""}
                name="couponCode"
                onKeyDown={e => {
                  if (e.keyCode === 13) this.onSubmitCode();
                }}
                underlineShow={this.props.isSundance ? false : true}
                onChange={e =>
                  this.setState({ enteredCode: e.target.value.trim() })
                }
              />
              <RaisedButton
                label={
                  this.props.isCheckingCode
                    ? this.props.salesLocked
                      ? "Unlocking..."
                      : "Applying..."
                    : this.props.salesLocked
                    ? "Unlock"
                    : "Apply"
                }
                disabled={this.props.isCheckingCode}
                primary={true}
                style={{ marginLeft: 7 }}
                onClick={this.onSubmitCode}
              />
              {this.props.couponError ? (
                <div style={this.props.isSundance ? { textAlign: "left", paddingTop: 10 } : {}}>{this.props.couponError}</div>
              ) : null}
              {!this.props.salesLocked && (
                <div>
                  <LinkLike
                    onClick={this.onResetCode}
                    style={this.props.isSundance
                      ? { display: "block", fontSize: 13, color: "#000" }
                      : { display: "block", fontSize: 13 }
                  }>
                    Never mind
                  </LinkLike>
                </div>
              )}
            </div>
          )
        ) : (this.props.showCouponEntry && !this.props.isCouponValid) ||
          (this.props.showGiftEntry && !this.props.order.gift) ? (
          <div style={styles.hint}>
            {this.props.showCouponEntry && !this.props.isCouponValid && (
              <div>
                <LinkLike 
                  onClick={this.onRevealClick} 
                  style={
                    this.props.isSundance 
                      ? { fontSize: 13, color: "#000" }
                      : { fontSize: 13 }
                  }
                  className={"eventive-discount-code"}
                >
                  Have a {this.props.isSundance ? "promo" : "discount"} code{offerGiftCard ? ` or gift card` : ""}?
                </LinkLike>
              </div>
            )}
            {this.props.showGiftEntry && !this.props.order.gift && (
              <div>
                <LinkLike onClick={this.onSubmitGift} style={{ fontSize: 13 }}>
                  Give as a gift
                </LinkLike>
              </div>
            )}
          </div>
        ) : null}
      </div>
    );
  }
}

export default OrderExtraEntry;



// WEBPACK FOOTER //
// ./src/app/components/partials/order-extra-entry.jsx